<div class="csr-form-wrapper">

  <form [formGroup]="form">
    <mat-card class="csr-card">

      <!-- ===== HEADER FIELDS ===== -->
      <mat-card-content class="header-section">
        <div class="header-fields-row">

          <mat-form-field appearance="fill" class="header-field">
            <mat-label>Business Segment</mat-label>
            <mat-select formControlName="businessSegmentId" required
              [matTooltip]="getSelectedName(businessSegments, businessSegmentId.value)"
              matTooltipPosition="above">
              <mat-option>
                <ngx-mat-select-search [searching]="searching" [formControl]="bsSearchCtrl"
                  noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Business Segment">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="null">None</mat-option>
              @for (bs of filteredBusinessSegments | async; track bs) {
                <mat-option [value]="bs.id"
                  [matTooltip]="bs.name" matTooltipPosition="right">
                  {{ bs.name }}
                </mat-option>
              }
            </mat-select>
            @if (businessSegmentId.touched && businessSegmentId.invalid && businessSegmentId.hasError('required')) {
              <mat-error>
                Business Segment is Required
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="header-field">
            <mat-label>Customer</mat-label>
            <mat-select formControlName="customerId" panelClass="dropdown-large" required
              [matTooltip]="getSelectedName(customers, customerId.value)"
              matTooltipPosition="above">
              <mat-option>
                <ngx-mat-select-search [searching]="searching" [formControl]="customerSearchCtrl"
                  noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Customer">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="null">None</mat-option>
              @for (c of filteredCustomers | async; track c) {
                <mat-option [value]="c.id"
                  [matTooltip]="c.name" matTooltipPosition="right">
                  {{ c.name }}
                </mat-option>
              }
            </mat-select>
            @if (customerId.touched && customerId.invalid && customerId.hasError('required')) {
              <mat-error>
                Customer is Required
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="header-field">
            <mat-label>Customer Branch</mat-label>
            <mat-select formControlName="customerBranchId" panelClass="dropdown-large" required
              [matTooltip]="getSelectedName(branches, customerBranchId.value)"
              matTooltipPosition="above">
              <mat-option>
                <ngx-mat-select-search [searching]="searching" [formControl]="branchSearchCtrl"
                  noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Branch">
                  <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                </ngx-mat-select-search>
              </mat-option>
              <mat-option [value]="null">None</mat-option>
              @for (b of filteredBranches | async; track b) {
                <mat-option [value]="b.id"
                  [matTooltip]="b.name" matTooltipPosition="right">
                  {{ b.name }}@if (b.code) {
                  <span> ({{ b.code }})</span>
                }
              </mat-option>
            }
          </mat-select>
          @if (customerBranchId.touched && customerBranchId.invalid && customerBranchId.hasError('required')) {
            <mat-error>
              Customer Branch is Required
            </mat-error>
          }
        </mat-form-field>

      </div>
    </mat-card-content>

    <!-- ===== DETAIL TABLE ===== -->
    <mat-card-content class="detail-section">
      <div class="detail-section-header">
        <div class="section-label">
          <span class="section-bar"></span>
          <span class="section-title-text">Service Requirements</span>
          <span class="row-count-chip">{{ details.length }}</span>
        </div>
        @if (!form.disabled) {
          <button mat-stroked-button type="button" class="add-row-btn"
            (click)="addRow()">
            <span class="add-btn-circle"><mat-icon>add</mat-icon></span>
            Add Row
          </button>
        }
      </div>

      <div class="service-container">
        <table class="csr-table">
          <thead class="fx-align-start-start fx-row">
            <th style="flex: 1 1 22%; box-sizing: border-box;">
              <div class="sorting_header">
                <span>Shipper
                  @if (!form.disabled) {
                    <a (click)="addDirectEntity(false)"
                      matTooltip="Add Shipper" matTooltipClass="white-tooltip" class="header-add-btn">
                      <mat-icon>add_circle</mat-icon>
                    </a>
                  }
                </span>
                <input [formControl]="headerShipperFilter" placeholder="Search..." class="mat-input-custom" type="search" autocomplete="off">
              </div>
            </th>
            <th style="flex: 1 1 22%; box-sizing: border-box;">
              <div class="sorting_header">
                <span>Consignee
                  @if (!form.disabled) {
                    <a (click)="addDirectEntity(true)"
                      matTooltip="Add Consignee" matTooltipClass="white-tooltip" class="header-add-btn">
                      <mat-icon>add_circle</mat-icon>
                    </a>
                  }
                </span>
                <input [formControl]="headerConsigneeFilter" placeholder="Search..." class="mat-input-custom" type="search" autocomplete="off">
              </div>
            </th>
            <th style="flex: 1 1 18%; box-sizing: border-box;">
              <div class="sorting_header">
                <span>Destination</span>
                <input [formControl]="headerDestinationFilter" placeholder="Search..." class="mat-input-custom" type="search" autocomplete="off">
              </div>
            </th>
            <th style="flex: 1 1 20%; box-sizing: border-box;">
              <div class="sorting_header">
                <span>Service <span class="required-star">*</span></span>
                <input [formControl]="headerServiceFilter" placeholder="Search..." class="mat-input-custom" type="search" autocomplete="off">
              </div>
            </th>
            <th style="flex: 1 1 5%; box-sizing: border-box;">
              <div class="sorting_header"><span>S-Bill</span></div>
            </th>
            <th style="flex: 1 1 5%; box-sizing: border-box;">
              <div class="sorting_header"><span>HBL</span></div>
            </th>
            <th style="flex: 1 1 10%; box-sizing: border-box;" class="plain-col">
              <div class="sorting_header"><span>Created By</span></div>
            </th>
            <th style="flex: 1 1 13%; box-sizing: border-box;" class="plain-col">
              <div class="sorting_header"><span>Date &amp; Time</span></div>
            </th>
            <th style="flex: 1 1 8%; box-sizing: border-box;" class="plain-col">
              <div class="sorting_header"><span>Remarks</span></div>
            </th>
            <th style="flex: 1 1 8%; box-sizing: border-box;" class="plain-col">
              <div class="sorting_header"><span>Action</span></div>
            </th>
          </thead>
          <tbody formArrayName="customerServiceRequirementDetails">
            @for (entry of filteredDetailEntries; track trackByEntry($index, entry)) {
              <tr class="fx-align-start-center fx-row" [formGroupName]="entry.index"
                [class.duplicate-row]="duplicateRowIndices.has(entry.index)"
                [class.locked-row]="entry.control.get('lockedAfterUseCsrService').value">
                <!-- Shipper -->
                <td style="flex: 1 1 22%; box-sizing: border-box;">
                  <mat-form-field appearance="fill">
                    <mat-select formControlName="shipperId" placeholder="Select Shipper"
                      [matTooltip]="getSelectedName(initialShippers, entry.control.get('shipperId').value)"
                      matTooltipPosition="above"
                      (selectionChange)="checkDuplicateRows()">
                      <mat-option>
                        <ngx-mat-select-search [searching]="searching"
                          [formControl]="shipperSearchCtrl"
                          noEntriesFoundLabel="No matching shipper found"
                          placeholderLabel="Search Shipper">
                          <mat-icon ngxMatSelectSearchClear>close</mat-icon>
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option [value]="null">- None -</mat-option>
                      @for (c of filteredRowShippers | async; track c) {
                        <mat-option [value]="c.id"
                          [matTooltip]="c.name" matTooltipPosition="right"
                        [style.display]="c._hidden ? 'none' : ''">{{ c.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </td>
                <!-- Consignee -->
                <td style="flex: 1 1 22%; box-sizing: border-box;">
                  <mat-form-field appearance="fill">
                    <mat-select formControlName="consigneeId" placeholder="Select Consignee"
                      [matTooltip]="getSelectedName(initialConsignees, entry.control.get('consigneeId').value)"
                      matTooltipPosition="above"
                      (selectionChange)="checkDuplicateRows()">
                      <mat-option>
                        <ngx-mat-select-search [searching]="searching"
                          [formControl]="consigneeSearchCtrl"
                          noEntriesFoundLabel="No matching consignee found"
                          placeholderLabel="Search Consignee">
                          <mat-icon ngxMatSelectSearchClear>close</mat-icon>
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option [value]="null">- None -</mat-option>
                      @for (c of filteredRowConsignees | async; track c) {
                        <mat-option [value]="c.id"
                          [matTooltip]="c.name" matTooltipPosition="right"
                        [style.display]="c._hidden ? 'none' : ''">{{ c.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </td>
                <!-- Destination -->
                <td style="flex: 1 1 18%; box-sizing: border-box;">
                  <mat-form-field appearance="fill">
                    <mat-select formControlName="destinationId" placeholder="Select Destination"
                      [matTooltip]="getSelectedName(destinations, entry.control.get('destinationId').value)"
                      matTooltipPosition="above"
                      (selectionChange)="checkDuplicateRows()">
                      <mat-option>
                        <ngx-mat-select-search [searching]="searching" [formControl]="rowDestinationSearchCtrl"
                          noEntriesFoundLabel="'no matching found'" placeholderLabel="Search Destination">
                          <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option [value]="null">- None -</mat-option>
                      @for (d of filteredDestinations | async; track d) {
                        <mat-option [value]="d.id"
                          [matTooltip]="d.name" matTooltipPosition="right"
                        [style.display]="d._hidden ? 'none' : ''">{{ d.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </td>
                <!-- Service (mandatory) -->
                <td style="flex: 1 1 20%; box-sizing: border-box;">
                  <mat-form-field appearance="fill">
                    <mat-select formControlName="serviceId" placeholder="Select Service"
                      [matTooltip]="getSelectedServiceLabel(entry.control.get('serviceId').value)"
                      matTooltipPosition="above"
                      (selectionChange)="checkDuplicateRows()">
                      <mat-option>
                        <ngx-mat-select-search [searching]="searching" [formControl]="serviceSearchCtrl"
                          noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Service">
                          <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (s of filteredServices | async; track s) {
                        <mat-option [value]="s.id"
                          [matTooltip]="s.serviceCode + ' - ' + s.serviceDescription" matTooltipPosition="right"
                          [style.display]="s._hidden ? 'none' : ''">
                          {{ s.serviceCode }} - {{ s.serviceDescription }}
                        </mat-option>
                      }
                    </mat-select>
                    @if (entry.control.get('serviceId').errors?.required) {
                      <mat-error class="mt-1">Required</mat-error>
                    }
                  </mat-form-field>
                </td>
                <!-- S-Bill Wise radio -->
                <td style="flex: 1 1 5%; box-sizing: border-box;" class="radio-cell" [class.radio-error]="billTypeErrorIndices.has(entry.index)">
                  <mat-radio-button [name]="'billType_' + entry.control.get('rowId').value" [checked]="entry.control.get('sBillWise').value"
                    (change)="onRadioChange(entry.index, 'sBillWise')"
                    [disabled]="entry.control.get('lockedAfterUseCsrService').value || form.disabled">
                  </mat-radio-button>
                </td>
                <!-- HBL Wise radio -->
                <td style="flex: 1 1 5%; box-sizing: border-box;" class="radio-cell" [class.radio-error]="billTypeErrorIndices.has(entry.index)">
                  <mat-radio-button [name]="'billType_' + entry.control.get('rowId').value" [checked]="entry.control.get('hblWise').value"
                    (change)="onRadioChange(entry.index, 'hblWise')"
                    [disabled]="entry.control.get('lockedAfterUseCsrService').value || form.disabled">
                  </mat-radio-button>
                  @if (billTypeErrorIndices.has(entry.index)) {
                    <mat-icon
                      class="bill-type-error-icon"
                      matTooltip="Please select S-Bill or HBL"
                    matTooltipPosition="above">error_outline</mat-icon>
                  }
                </td>
                <!-- Created By (read-only) -->
                <td style="flex: 1 1 10%; box-sizing: border-box;" class="plain-col">
                  <span class="readonly-text">{{ entry.control.get('displayCreatedBy').value }}</span>
                </td>
                <!-- Date & Time (read-only) -->
                <td style="flex: 1 1 13%; box-sizing: border-box;" class="plain-col">
                  <span class="readonly-text">{{ entry.control.get('displayCreatedDate').value | date:'dd/MM/yyyy hh:mm a' }}</span>
                </td>
                <!-- Remarks button -->
                <td style="flex: 1 1 8%; box-sizing: border-box;" class="plain-col remarks-cell">
                  <button mat-icon-button type="button" class="remarks-btn"
                    (click)="openRemarksDialog(entry.index)"
                    [matTooltip]="entry.control.get('remarksCount').value ? (entry.control.get('remarksCount').value + ' remark(s) — click to view/add') : 'Click to add remarks'"
                    matTooltipPosition="above">
                    <mat-icon>chat</mat-icon>
                    @if (entry.control.get('remarksCount').value) {
                      <span class="remarks-count-badge">
                        {{ entry.control.get('remarksCount').value }}
                      </span>
                    }
                  </button>
                </td>
                <!-- Action -->
                <td style="flex: 1 1 8%; box-sizing: border-box;" class="plain-col action-cell">
                  @if (entry.control.get('lockedAfterUseCsrService').value) {
                    <mat-icon class="lock-icon"
                    matTooltip="Row is locked — used in a transaction">lock</mat-icon>
                  }
                  @if (!form.disabled) {
                    <span class="__action_edit_icon copy-icon" (click)="copyRow(entry.index)"
                      matTooltip="Copy Row">
                      <mat-icon>content_copy</mat-icon>
                    </span>
                  }
                  @if (!form.disabled) {
                    <span class="__action_edit_icon delete-icon" (click)="removeRow(entry.index)"
                      matTooltip="{{ entry.control.get('lockedAfterUseCsrService').value ? 'Row is locked (used in transaction)' : 'Remove Row' }}"
                      >
                      <mat-icon>delete</mat-icon>
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Duplicate warning -->
      @if (duplicateRowIndices.size > 0) {
        <div class="duplicate-warning">
          <mat-icon>warning_amber</mat-icon>
          Duplicate combination found — highlighted rows have the same Shipper, Consignee, Destination and Service.
        </div>
      }
    </mat-card-content>

    <!-- ===== FORM ACTIONS ===== -->
    <mat-card-actions class="form-actions" align="end">
      @if (getSaveBtnCondition()) {
        <button mat-raised-button color="primary" (click)="onSave()"
          [disabled]="duplicateRowIndices.size > 0">
          <mat-icon>save</mat-icon>
          Save
        </button>
      }
      <button mat-raised-button type="button" (click)="onCancel()">
        Cancel
      </button>
    </mat-card-actions>

    <!-- ===== AUDIT HISTORY (edit mode only) ===== -->
    <mat-card-content style="margin-top: 3%;">
      @if (id.value) {
        <div class="audit-log">
          <button mat-stroked-button type="button" [class.active]="viewLog.value"
              (click)="viewLog.setValue(!viewLog.value)">
              <mat-icon>history</mat-icon> View Log
          </button>
        </div>
      }
      @if (viewLog.value) {
        <app-history [referenceType]="'CUSTOMER_SERVICE_REQUIREMENT'" [referenceId]="id.value" [processAuditData]="processAuditData"></app-history>
      }
    </mat-card-content>

  </mat-card>
</form>
</div>
